import React from 'react';
import PureRenderMixin from 'react-pure-render/mixin';
import { Row, Col } from 'bootstrap';

import TrackableUserPicker from 'main/components/show/cuesheet/trackableUserPicker.jsx';
//import TrackingResumeLink from 'main/components/show/cuesheet/trackingResumeLink.jsx'
import OnlineIndicator from 'shared/components/misc/onlineIndicator.jsx';

/**
 * Cuesheet (responsive) Footer
 *
 */
export default React.createClass({
  displayName: 'CuesheetFooter',

  mixins: [PureRenderMixin],

  render() {
    return (
      <footer className="container-fluid csr-footer">
        <Row>
          <Col lg={16} md={16} sm={16} xs={24}>
            <TrackableUserPicker />
          </Col>
          <Col
            className="csr-footer-online-indicator"
            lg={8}
            md={8}
            sm={8}
            xs={2}
          >
            <OnlineIndicator />
          </Col>
        </Row>
      </footer>
    );
  },
});
